<template>
  <div class="main">
    <div class="body">
      <div class="border">
        <div class="title">人格特质</div>
        <div class="txt">
          <p style="text-indent: 2rem; font-weight: bold; margin-top: 30px">
            世界管理学大师彼得德鲁克说：大部分人不知道他们的优势何在。如果你问他们，他们就会呆呆地看着你，或文不对题地大谈自己的具体知识。事实证明，即使在德鲁克如此断言的几十年后人们对自己的认识仍然很茫然。
          </p>
          <p style="text-indent: 2rem; font-weight: bold">
            显然人们的职业发展和许多因素相关，如体力、脑力状况、个人兴趣、个性特征、家庭环境、所处的大环境、就业市场、能力、技能、教育以及性别等等。但个性在职业发展确实提供了不同个性类型的人擅长扮演不同的角色，不同个性类型的人需要不同的工作氛围使他们的工作富有成效，并且开心愉快。
          </p>
          <p style="text-indent: 2rem; font-weight: bold">
            人格特质了解的目的不是像吉普赛女郎的水晶球告诉你你最合适那个工作，而是告诉你哪种特性工作适合你的，通常给你提供工作组群，而且更能帮助你挖掘出你个性全面因素，并知道你将这些因素运用到新的工作和新的环境中，这样你的职业适应性增强了。这在就业市场变化多端，人们越来越不可能在一个企业从一而终工作到退休，而是需要改变观念主动出击，掌握自己的职业发展轨迹，不断提升自我职业价值，这种指导性显得尤为重要。
          </p>
          <div style="margin-left: 20px; margin-top: 30px; font-size: 18px">
            你的气质类型: <span>{{ rgtz.Title }}</span>
            <div>关键词描述：{{ rgtz.DescChs }}</div>
            <el-row>
              <el-col :span="4"><img style="width:100px" :src="rgtz.PicSrc" alt=""></el-col>
              <el-col :span="12">
                <div>名称：{{ rgtz.Author }}</div>
                <div style="color:gray;font-size:12px">经典语录:{{ rgtz.Postscript }}

                </div>
              </el-col>
            </el-row>

            <div>性格分析：</div>
            <div v-html="rgtz.Advantage" style="padding-left: 50px"></div>
            系统建议：
            <div v-html="rgtz.Inferiority" style="padding-left: 50px"></div>
            职业建议：
            <div v-html="rgtz.SuitableField" style="padding-left: 50px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["rgtz"],
  name: "",
  
  
  
};
</script>


<style scoped lang='less'>
.content {
  max-width: 800px;
  margin: 0 auto;
}
.main {
  .home_page {
    background-image: linear-gradient(#8950d5, #bb85e7);
    color: white;
    overflow: hidden;
    margin-bottom: 30px;
  }
  .body {
    padding: 20px;
  }
  .border {
    padding: 20px;
    padding-bottom: 40px;
    border: 1px solid #c4a7e9;
    position: relative;
    margin-top: 57px;
    .title {
      position: absolute;
      top: -23px;
      left: 276px;
      height: 41px;
      width: 200px;
      background: #c4a7e9;
      text-align: center;
      line-height: 40px;
      color: white;
    }
  }

  .tables {
    border: 1px solid #c4a7e9;
  }

  .line div {
    padding: 6px;
    font-weight: bold;
    background-color: #ffffff;
  }
  .l {
    float: left;
  }
  .r {
    float: right;
    margin-bottom: 0px;
  }
}
.n_title {
  display: inline-block;
  text-indent: 2rem;
  position: relative;
  left: -21px;
  background: #c4a7e9;
  color: white;
  margin-top: 90px;
  margin-bottom: 20px;
  width: 300px;
}
.right {
  display: inline-block;
  width: 400px;
  span {
    width: 20%;
    text-align: center;
    display: inline-block;
  }
}
.txt {
  line-height: 30px;
}
#chart {
  width: 500px;
  height: 500px;
  margin: 100px auto 0;
}
.tables1 {
  margin-top: 10px;
  border-collapse: collapse;
  td {
    border: 1px solid rgb(173, 169, 169);
  }
}
.print {
  position: fixed;
  bottom: 100px;
  right: 200px;
}
</style>
